module.exports = __webpack_public_path__ + "pc/img/img_about_03.3ca272c4.png";